(function () {
  "use strict";

  var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  document.addEventListener("DOMContentLoaded", function () {
    // ---- Scroll reveal ----
    var revealTargets = document.querySelectorAll(
      "main section, main .shopify-section > *:first-child"
    );
    if ("IntersectionObserver" in window && !reducedMotion) {
      revealTargets.forEach(function (el) {
        if (
          !el.hasAttribute("data-cinematic-reveal") &&
          !el.closest("[data-cinematic-reveal]") &&
          !el.closest(".entry-page") &&
          !el.classList.contains("entry-page")
        ) {
          el.setAttribute("data-cinematic-reveal", "");
        }
      });
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-in-view");
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: "0px 0px -80px 0px" }
      );
      document.querySelectorAll("[data-cinematic-reveal]").forEach(function (el) {
        io.observe(el);
      });
    }

    // ---- Parallax on hero / banner media (desktop only — disabled on small screens for smoothness) ----
    var parallaxEls = document.querySelectorAll("[data-cinematic-parallax] img, [data-cinematic-parallax] video");
    var isMobileViewport = window.matchMedia("(max-width: 749px)").matches;
    if (parallaxEls.length && !reducedMotion && !isMobileViewport) {
      var ticking = false;
      function updateParallax() {
        parallaxEls.forEach(function (el) {
          var wrap = el.closest("[data-cinematic-parallax]");
          var rect = wrap.getBoundingClientRect();
          var progress = 1 - (rect.top + rect.height / 2) / (window.innerHeight + rect.height);
          var offset = (progress - 0.5) * 60;
          el.style.transform = "translateY(" + offset.toFixed(1) + "px) scale(1.12)";
        });
        ticking = false;
      }
      window.addEventListener(
        "scroll",
        function () {
          if (!ticking) {
            window.requestAnimationFrame(updateParallax);
            ticking = true;
          }
        },
        { passive: true }
      );
      updateParallax();
    }

    // ---- Magnetic buttons ----
    if (!reducedMotion && matchMedia("(hover: hover)").matches) {
      document.querySelectorAll("[data-cinematic-magnetic]").forEach(function (btn) {
        btn.addEventListener("mousemove", function (e) {
          var rect = btn.getBoundingClientRect();
          var x = e.clientX - rect.left - rect.width / 2;
          var y = e.clientY - rect.top - rect.height / 2;
          btn.style.transform = "translate(" + (x * 0.18).toFixed(1) + "px, " + (y * 0.28).toFixed(1) + "px)";
        });
        btn.addEventListener("mouseleave", function () {
          btn.style.transform = "translate(0,0)";
        });
      });
    }

    // ---- Safety net: never let any full-screen overlay trap the page ----
    // If something with role/aria-hidden=false and fixed positioning covering
    // the viewport is still around after 6s (e.g. the entry-page splash failed
    // to dismiss for any reason), force it away so the site is never stuck.
    window.setTimeout(function () {
      var stuckEntry = document.querySelector(".entry-page:not(.entry-page--dismissed)");
      if (stuckEntry && getComputedStyle(stuckEntry).display !== "none") {
        stuckEntry.classList.add("entry-page--dismissed");
        stuckEntry.style.display = "none";
        document.documentElement.style.overflow = "";
      }
    }, 6000);
  });
})();
